var render = function () {
  var _this$filter;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Category AX'
      }],
      "title": "All Category AX"
    }
  }), _c('div', {
    staticClass: "bg-white rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex justify-between px-4 py-3 items-center align-middle"
  }, [_c('div', {
    staticClass: "block relative"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 left-3",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "d": "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter,
      expression: "filter"
    }],
    staticClass: "bg-white rounded-lg py-2 px-11 border w-96",
    attrs: {
      "placeholder": "Search Name, Code"
    },
    domProps: {
      "value": _vm.filter
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value;
      }, _vm.filterCategoryAX]
    }
  }), (_this$filter = this.filter) !== null && _this$filter !== void 0 && _this$filter.length ? _c('button', {
    staticClass: "absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.actionReset
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()])]), _c('div', {
    staticClass: "w-full"
  }, [_c('TableCategoryAx', {
    attrs: {
      "currentpage": _vm.currentPage,
      "perpage": _vm.perPage,
      "data": _vm.item,
      "isLoading": _vm.isLoading
    }
  })], 1), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 items-center mt-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }